import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { putNotificationData } from "../utility/putNotificationData";
import { createEvent } from "../utility/createEvent";
import { getPushSubscriptionData } from "../utility/getPushSubscriptionData";
import { mainTextColor } from "../utility/colorPalette";
import { useAuth } from "../../context/AuthContext";

interface ReminderData {
  userId: string;
  notificationIsOn: boolean;
  notificationTime: string;
}

interface ReminderSettingDialogProps {
  isOn: boolean;
  setIsOn: React.Dispatch<React.SetStateAction<boolean>>;
  setReminderSettings: React.Dispatch<
    React.SetStateAction<ReminderData | null>
  >;
}

export const ReminderSettingDialog: React.FC<ReminderSettingDialogProps> = ({
  isOn,
  setIsOn,
  setReminderSettings,
}) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const { idToken, refreshAuthSession } = useAuth();
  const [inputReminderTime, setInputReminderTime] = useState<string>(
    getCurrentTimeString()
  );

  // 設定保存処理が実行中
  const [saveActivate, setSaveActivate] = useState<boolean>(false);

  const registerNotification = () => {
    setSaveActivate(true);

    if (!idToken) return;
    // Dynamoに情報を保存
    putNotificationData(
      {
        userId: user.userId,
        notificationTime: inputReminderTime,
      },
      idToken
    ).then((data) => {
      if (data.status === 200) {
        const tmpSettings: ReminderData = {
          userId: user.userId,
          notificationIsOn: true,
          notificationTime: inputReminderTime,
        };
        setReminderSettings(tmpSettings);
      }
      setIsOn(false);
      setSaveActivate(false);
    });

    // EventBridgeにイベントを保存
    if (!idToken) return;
    getPushSubscriptionData(user.userId, idToken).then((data) => {
      const subscription = data.subscription;
      createEvent(
        {
          userId: user.userId,
          time: inputReminderTime,
          subscription: subscription,
        },
        idToken
      );
    });
  };

  return (
    <>
      <Dialog open={isOn}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DialogTitle>リマインダ登録</DialogTitle>
          <DialogContent>
            <DialogContentText>
              通知を受け取りたい時間を設定してください。
            </DialogContentText>
            <TextField
              type="time"
              value={inputReminderTime}
              onChange={(e) => setInputReminderTime(e.target.value)}
              inputProps={{ step: 60 * 15 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsOn(false)}>キャンセル</Button>
            <Button variant="contained" onClick={registerNotification}>
              登録
            </Button>
          </DialogActions>
        </LocalizationProvider>
      </Dialog>

      <Dialog open={saveActivate}>
        <DialogContent sx={{ textAlign: "center" }}>
          <Typography variant="body2" color={mainTextColor}>
            設定を保存しています
          </Typography>
          <CircularProgress />
        </DialogContent>
      </Dialog>
    </>
  );
};

function getCurrentTimeString(): string {
  const now = new Date();
  const hh = String(now.getHours()).padStart(2, "0");
  const mm = String(now.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
}
